import React, { forwardRef, useState } from 'react'
import DayFilteringWidget from '../student/DayFilteringWidget'
import CheckInWidget from '../student/CheckInWidget'
import EmotionsCheckInFrequency from './EmotionsCheckInFrequency'
import WellbeingComparisonWidget from '../counsellor/WellbeingComparisonWidget'
import ReasonsForEmotions from '../student/ReasonsForEmotionsWidget'
import DetailsOnEmotions from '../student/DetailsOnEmotions'
import { daysFilterList } from '../class/ClassAnalyticsWidgets'
import AnalyticsWidgetEvents from '../../../analytics/AnalyticsWidgetEvents'

const OrganizationAnalyticsWidgets = forwardRef(({ selectedOptions, daysFilter, setDaysFilter }, ref) => {
    return (
        <div ref={ref} className="flex-1 overflow-x-hidden px-2 pt-[20px]  overflow-y-auto">
            <AnalyticsWidgetEvents
                subjectId={JSON.stringify(selectedOptions)}
                widgets={[
                    { key: 'check-in', label: 'Check-in' },
                    { key: 'wellbeing-comparison', label: 'Wellbeing comparison' },
                    { key: 'emotion-frequency', label: 'Emotion check-in frequency' },
                    { key: 'emotion-details', label: 'Emotion details' },
                    { key: 'emotion-reasons', label: 'Reasons for emotions' },
                ]}
            />
            <DayFilteringWidget daysFilter={daysFilter} daysFilterList={daysFilterList} setDaysFilter={setDaysFilter} />
            <div className="w-full h-[1px] bg-white mt-4"></div>
            <CheckInWidget daysFilter={daysFilter} isCounsellor selectedUsersScope={selectedOptions} analyticsType="organization" />
            <WellbeingComparisonWidget daysFilter={daysFilter} isCounsellor selectedUsersScope={selectedOptions} analyticsType="organization" />
            <EmotionsCheckInFrequency daysFilter={daysFilter} selectedUsersScope={selectedOptions} />
            <DetailsOnEmotions daysFilter={daysFilter} isCounsellor selectedUsersScope={selectedOptions} analyticsType="organization" />
            <ReasonsForEmotions daysFilter={daysFilter} isCounsellor selectedUsersScope={selectedOptions} analyticsType="organization" />
        </div>
    )
})

export default OrganizationAnalyticsWidgets
